module.exports = __webpack_public_path__ + "static/media/arrow-left.ab73b10e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-left.svg
// module id = 239
// module chunks = 0